module.exports = __webpack_public_path__ + "img/bag.cdcc4bc5.svg";